
function LoaderDots() {
  return (
    <div className="flex flex-row gap-2">
      <div className="w-5 h-5 rounded-full bg-primary animate-bounce [animation-delay:.7s]"></div>
      <div className="w-5 h-5 rounded-full bg-secondary animate-bounce [animation-delay:.3s]"></div>
      <div className="w-5 h-5 rounded-full bg-primary animate-bounce [animation-delay:.7s]"></div>
    </div>
  );
}

export default LoaderDots;
